import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SnakeBlock from "../SnakeBlock";
import ConnectorBlock from "../ConnectorBlock";
import Button from "../Button";
import { checkCurrentMemory } from "../../utils/localStorage";
import { getUserCurrentDate } from "../../utils/getUserCurrentDate";
import PreSolutionCheckModal from "../Modal/PreSolutionCheckModal";
import { getDateUSAFormat } from "../../utils/getUserCurrentDate";

const WebShare = ({ blocks, isMobile, puzzleDate }) => {
    const memory = checkCurrentMemory();
    const today = getUserCurrentDate();
    const defaultShowSnake = memory?.lastDayPlayed === today && (memory?.gameStatus ===  'game won' || memory?.gameStatus === 'game over');
    const [showSnake, setShowSnake] = useState(defaultShowSnake);
    const navigate = useNavigate();

    const createSnake = () => {
        return (
            <>
                {
                    blocks.map((block, idx) => {
                        return (
                            <React.Fragment key={idx}>
                                <SnakeBlock showGoBack={() => console.log(idx)} key={block.id} info={block} />
                                {idx !== blocks.length - 1 && <ConnectorBlock isMobile={isMobile} height={50} color={'black'} key={idx} />}
                            </React.Fragment>
                        )
                    })
                }
            </>
        )
    }

    return (
        <div style={{backgroundColor:'black', color:'#ccc'}}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%',}}>
                <p style={{ fontWeight: 'bolder', fontSize: 44 }}>I solved the snake on <br/> {getDateUSAFormat(puzzleDate)} in {Math.max(0, (blocks?.length ?? 0) - 2)} moves!</p>
                <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <Button onClick={() => navigate('/')} text="Let me try!" />
                </div>
            </div>
            {showSnake ? 
                <div className="share-container">
                    <div className="scroll-container-share">
                        <div className="scroll-content-share">
                            {createSnake()}
                        </div>
                    </div>
                </div>
                :
                <PreSolutionCheckModal show={true} showSolution={() => setShowSnake(true)} />
            }
        </div>
    );
}

export default WebShare;